/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_Strength_TrainingInputs */

const en_service_type_strength_training = /** @type {(inputs: Service_Type_Strength_TrainingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strength training`)
};

const pl_service_type_strength_training = /** @type {(inputs: Service_Type_Strength_TrainingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trening siłowy`)
};

/**
* | output |
* | --- |
* | "Strength training" |
*
* @param {Service_Type_Strength_TrainingInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_strength_training = /** @type {((inputs?: Service_Type_Strength_TrainingInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_Strength_TrainingInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_strength_training(inputs)
	return en_service_type_strength_training(inputs)
});